import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {REDIRECT_TO_LEGACY_LOGIN} from 'app/core/helpers/redirect';
import {AuthService} from 'app/core/services/auth.service';
import {FormService} from 'app/core/services/form.service';

@Component({
    selector: 'sign-out',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.scss'],
    providers: [FormService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignOutComponent implements OnInit {
    constructor(
        private auth: AuthService,
        public formService: FormService,
        @Inject(REDIRECT_TO_LEGACY_LOGIN) public redirectToLogin: () => void
    ) {}

    ngOnInit() {
        this.auth.signOut().subscribe(
            () => this.redirectToLogin(),
            err => this.formService.catchError(err)
        );
    }
}
